import ReactApexChart from 'react-apexcharts'
import {useSelector, useDispatch} from 'react-redux'
import {
  getTotalExamParticipation,
  getTotalExamParticipationOptions,
  selectTotalExamParticipation
} from '../../../data/StudyPeriod/studyPeriodSlice'
import {Spinner} from 'react-bootstrap'
import {useQuery} from 'react-query'

const TotalExamParticipation = () => {
  const totalExamParticipation = useSelector(selectTotalExamParticipation)
  const chartOptions = getTotalExamParticipationOptions()
  const dispatch = useDispatch()

  const {isLoading} = useQuery({
    queryKey: ['TotalExamParticipation'],
    queryFn: () => dispatch(getTotalExamParticipation(totalExamParticipation) as any),
  })

  return (
    <div>
      <div className={`card`}>
        {/* begin::Body */}
        <div className='card-body'>
          {isLoading ? (
            <Spinner animation='border' variant='secondary' />
          ) : (
            <ReactApexChart
              options={chartOptions as any}
              series={totalExamParticipation.series}
              type='area'
              height={400}
            />
          )}
        </div>
        {/* end::Body */}
      </div>
    </div>
  )
}

export default TotalExamParticipation
